export default __webpack_public_path__ + "static/media/react-native-firebase-1.3b14b81b.svg";